import {memo, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import Login from './Login';
import Menu from './Menu';
import Share from './Share';
import TalkToUs from './TalkToUs';
import Register from './Register';
import ForgottenPassword from './ForgottenPassword';
import Header from './Header';

import { AnimatePresence } from 'framer-motion';


const Sidebar = memo(() => {

    // Get the state of the sidebar.
    let {sidebar, state} = useSelector((state) => state.sidebar)

    const dispatch = useDispatch();

    const closeSidebarHandler = () => {
        dispatch({ type : 'CLOSE_SIDEBAR' });
    }

    useEffect(() => {
        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        }

        // load the script by passing the URL
        loadScriptByURL("recaptcha-key", 'https://www.google.com/recaptcha/api.js?render=6Ldes10aAAAAAH1XvUCOncf4v5udtHa282dtRCRU', function () {
            console.log("Script loaded!");
        });
    }, []);

    useEffect(() => {
        if ( state ) {
            document.addEventListener( 'focusin', sidebarFocusOnly )
        } else {
            document.removeEventListener( 'focusin', sidebarFocusOnly )
        }
    }, [state])

    const sidebarFocusOnly = (evt) => {
        const parent = document.getElementById( 'sidebar' );
        if ( ! isDescendant( parent, evt.target ) ) {
            document.getElementsByClassName('first-focus')[0].focus();
        }
    }

    const isDescendant = (parent, child) => {
        var node = child.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }

    return (
        <div id="sidebar" className={`sidebar ${state ? 'open' : ''}`}>
            <div className="sidebar--content">
                <div>
                    <Header />

                    <AnimatePresence exitBeforeEnter>
                        { 'login' === sidebar && <Login mode={sidebar} /> }
                        { 'forgotten' === sidebar && <ForgottenPassword mode={sidebar} /> }
                        { 'register' === sidebar && <Register mode={sidebar} /> }
                        { 'share' === sidebar && <Share mode={sidebar} /> }
                        { 'TalkToUs' === sidebar && <TalkToUs mode={sidebar} /> }
                        { 'menu' === sidebar && <Menu mode={sidebar} /> }
                    </AnimatePresence>
                </div>
            </div>
            <div className="sidebar--bg" onClick={closeSidebarHandler}></div>
        </div>
    );
});

export default Sidebar;